import "./QualificationLifecycleServices.module.css";
import Header from "@/reusable_sections/Header";
import LifecycleHero from "./sections/LifecycleHero";
import Compliance from "./sections/Compliance";
import Lifecycle from "./sections/Lifecycle";
import LifecycleInquiry from "./sections/LifecycleInquiry";
import Footer from "@/reusable_sections/Footer";
export default function QualificationLifecycleServicesPage() {
  return <div>
      <Header />
      <LifecycleHero />
      <Compliance />
      <Lifecycle />
      <LifecycleInquiry />
      <Footer />
    </div>;
}